import { useCallback } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';

import { TAB_KEYS } from '../constants';

export const useResourcesPageUIAnalytics = () => {
	const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(true);
	const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

	const sendResourceFilterClickUIEvent = useCallback(
		(selectedFilter: TAB_KEYS) => {
			fireUIEvent({
				action: ActionKey.CLICKED,
				actionSubject: ActionSubjectKey.BUTTON,
				actionSubjectId: ActionSubjectIdKey.RESOURCE_FILTER,
				source: sourceKey,
				attributes: {
					selectedFilter,
				},
			});
		},
		[fireUIEvent, sourceKey],
	);

	const sendResourceLinkClickUIEvent = useCallback(
		(resourceSubject: string, resourceCategory: TAB_KEYS) => {
			fireUIEvent({
				action: ActionKey.CLICKED,
				actionSubject: ActionSubjectKey.LINK,
				actionSubjectId: ActionSubjectIdKey.RESOURCE_LINK,
				source: sourceKey,
				attributes: {
					resourceSubject,
					resourceType: resourceCategory,
				},
			});
		},
		[fireUIEvent, sourceKey],
	);

	const sendUsefulLinkClickUIEvent = useCallback(
		(linkSubject: string) => {
			fireUIEvent({
				action: ActionKey.CLICKED,
				actionSubject: ActionSubjectKey.LINK,
				actionSubjectId: ActionSubjectIdKey.USEFUL_LINK,
				source: sourceKey,
				attributes: {
					linkSubject,
				},
			});
		},
		[fireUIEvent, sourceKey],
	);

	return {
		sendResourceFilterClickUIEvent,
		sendResourceLinkClickUIEvent,
		sendUsefulLinkClickUIEvent,
	};
};
